import type { PostItem } from "@/types/content";

export const posts: PostItem[] = [
  {
    id: "1",
    title: "第一次尝试轻挠体验，比想象中放松多了",
    author: "橘子汽水",
    date: "2026-10-16",
    updatedAt: "2026-10-17 09:12",
    replyCount: 42,
    heat: 97,
    essence: true,
    excerpt:
      "本来以为会很尴尬，结果两个人笑到停不下来。记录一下这次体验，顺便谢谢社区里给建议的朋友。",
    content: [
      "关注这个话题有一阵子了，一直没敢尝试。上周终于和室友约好，用一个下午认真地试了一次。",
      "准备工作比想象中简单：一条毯子、一根羽毛、一杯热水。我们提前说好了哪里可以碰、觉得不舒服就举手，整个氛围一下子就轻松了。",
      "最意外的收获是，笑完之后那种松下来的感觉特别明显。平时工作累到睡不着，那天晚上居然十一点就困了。",
      "所以想跟还在犹豫的朋友说：不用把这件事想得太复杂，把它当成一个轻松的小游戏就好。当然，一定要和愿意一起玩的人一起。",
    ],
    replies: [
      {
        author: "暖光小屋",
        date: "2026-10-16 21:40",
        content: "看到这条好开心，提前沟通真的是最重要的一步。祝你们之后的每次体验都这么舒服。",
      },
      {
        author: "小鹿乱撞",
        date: "2026-10-17 08:05",
        content: "我也一直不敢开口问室友，看了你的记录决定这周末试试看。",
      },
      {
        author: "慢慢玩工作室",
        date: "2026-10-17 09:12",
        content: "「把它当成一个轻松的小游戏」这句话说得太好了，新手最需要的就是这种心态。",
      },
    ],
  },
  {
    id: "2",
    title: "大家都喜欢什么道具？来聊聊你的第一名",
    author: "道具实验室",
    date: "2026-10-15",
    updatedAt: "2026-10-17 10:30",
    replyCount: 87,
    heat: 99,
    essence: true,
    excerpt:
      "羽毛、棉签、软毛刷、丝巾、手指……每个人心里的第一名都不一样。做个小小的统计，顺便收集一下冷门道具。",
    content: [
      "最近在整理大家的反馈，发现道具偏好差异特别大。有人觉得羽毛最温柔，有人觉得羽毛太飘忽反而紧张。",
      "我们内部投票的结果是：丝巾第一、羽毛第二、软毛刷第三。手指排在最后，理由是「太容易失控」。",
      "想在这里做个小统计，也欢迎分享一些冷门但好用的道具。注意别推荐尖锐或者可能伤到皮肤的东西，安全第一。",
    ],
    replies: [
      {
        author: "橘子汽水",
        date: "2026-10-15 19:22",
        content: "丝巾加一，柔柔的又不会飘走，新手友好度满分。",
      },
      {
        author: "夜猫子小林",
        date: "2026-10-16 01:14",
        content: "我用的是化妆刷里最软的那种，面积大又均匀，推荐试试。",
      },
      {
        author: "阿栗",
        date: "2026-10-17 10:30",
        content: "提醒一下大家，道具使用前后记得清洁，接触皮肤的东西还是要注意卫生。",
      },
    ],
  },
  {
    id: "3",
    title: "分享一个不尴尬的互动小约定",
    author: "小鹿乱撞",
    date: "2026-10-14",
    updatedAt: "2026-10-16 22:18",
    replyCount: 31,
    heat: 91,
    essence: false,
    excerpt:
      "我们用一个很简单的方式解决了「不好意思开口」的问题，分享给同样容易害羞的朋友。",
    content: [
      "我和朋友都属于那种不太好意思直接说「我不想」的人，所以经常玩到一半两个人都别扭。",
      "后来我们约定：开始前各自在手机上打三个词，分别是「想试的」「不想的」「随时可以停的信号」。互相看一眼，不用当场说出来。",
      "这个方法对我们特别有效，因为不用面对面讲那些有点难为情的话。现在每次都很轻松。",
    ],
    replies: [
      {
        author: "内容编辑 小满",
        date: "2026-10-15 10:02",
        content: "这个方式很聪明，把难开口的部分变成了一个小小的仪式感。",
      },
      {
        author: "橘子汽水",
        date: "2026-10-16 22:18",
        content: "学到了，下次也试试。我们之前是直接说，确实有点尴尬。",
      },
    ],
  },
  {
    id: "4",
    title: "有没有人和我一样，特别怕痒但又很好奇",
    author: "南风知我意",
    date: "2026-10-13",
    updatedAt: "2026-10-15 16:45",
    replyCount: 56,
    heat: 88,
    essence: false,
    excerpt:
      "属于那种一碰就笑到不行的类型，所以一直只敢看视频。想问问大家有没有类似的体验。",
    content: [
      "我是真的很怕痒，剪个脚趾甲都要笑出声的那种。所以一直只在社区里看看大家的分享。",
      "但看久了又很好奇，是不是可以从特别温和的方式开始？比如只是用羽毛扫一下脚背之类的。",
      "想听听和我一样怕痒的朋友，是怎么迈出第一步的。",
    ],
    replies: [
      {
        author: "慢慢玩工作室",
        date: "2026-10-14 09:30",
        content: "可以试试从脚背、脚踝这些不那么敏感的位置开始，先建立「不会有突然袭击」的信任感。",
      },
      {
        author: "橘子汽水",
        date: "2026-10-15 16:45",
        content: "我也超怕痒，第一次只玩了大概三分钟，感觉刚刚好，不用勉强自己坚持很久。",
      },
    ],
  },
  {
    id: "5",
    title: "周末在家可以玩的轻松小游戏合集",
    author: "夜猫子小林",
    date: "2026-10-12",
    updatedAt: "2026-10-14 20:03",
    replyCount: 24,
    heat: 84,
    essence: false,
    excerpt:
      "整理了几个完全不需要道具、两个人就能玩起来的小游戏，适合下雨的周末。",
    content: [
      "最近天气不好，周末基本都在家。整理了三个我们常玩的小游戏，都很简单。",
      "第一个是猜道具：闭眼猜碰在脚心的是什么，猜错就接受十秒轻挠。第二个是憋笑挑战：谁先笑谁输。第三个是限时体验：设一个三分钟闹钟，铃响就结束，谁也不能赖账。",
      "重点都是「轻松」和「随时能停」，不要玩到有人真的不舒服。",
    ],
    replies: [
      {
        author: "小鹿乱撞",
        date: "2026-10-13 11:11",
        content: "限时那个很实用，有时候玩太久反而累。",
      },
      {
        author: "南风知我意",
        date: "2026-10-14 20:03",
        content: "收藏了，下个周末拉朋友试第一个。",
      },
    ],
  },
  {
    id: "6",
    title: "想问问大家第一次的体验感受",
    author: "柠檬不太酸",
    date: "2026-10-10",
    updatedAt: "2026-10-12 14:27",
    replyCount: 38,
    heat: 80,
    essence: false,
    excerpt:
      "第一次玩完之后有点说不上来的感觉，既放松又有点害羞。想知道大家是不是也这样。",
    content: [
      "上周第一次和朋友一起玩，全程大概十几分钟。感觉挺奇妙的，笑得很厉害，但结束后又有种被照顾到的感觉。",
      "不过也有点说不上来的害羞，事后还认真反省了一下自己是不是太夸张了。",
      "想问大家的第一次都是什么感受？",
    ],
    replies: [
      {
        author: "阿栗",
        date: "2026-10-11 09:20",
        content: "害羞是很正常的，尤其是第一次。能笑出来说明你是放松的，不用反省。",
      },
      {
        author: "夜猫子小林",
        date: "2026-10-12 14:27",
        content: "我也是这样，第二次就自然多了。",
      },
    ],
  },
  {
    id: "7",
    title: "冷知识：脚心的敏感度在全身排第几？",
    author: "科普小组",
    date: "2026-10-09",
    updatedAt: "2026-10-11 10:55",
    replyCount: 19,
    heat: 76,
    essence: true,
    excerpt:
      "查了点资料，顺便把常见的「怕痒部位」做了个轻松的排序，结果和直觉差不多。",
    content: [
      "严格来说，敏感度并没有一个公认的官方排名，不同研究的测量方式也不一样。但从日常反馈看，脚心、腋下、腰侧基本稳居前列。",
      "脚心之所以格外明显，一部分原因是神经末梢密集，另一部分原因是它很少被自己看到，大脑对那个区域的触碰缺少预判。",
      "所以「怕痒」不是矫情，是很正常的生理反应。每个人的敏感度不一样，互相尊重就好。",
    ],
    replies: [
      {
        author: "柠檬不太酸",
        date: "2026-10-10 08:40",
        content: "原来缺少预判也算原因，涨知识了。",
      },
      {
        author: "南风知我意",
        date: "2026-10-11 10:55",
        content: "难怪自己挠自己完全没感觉。",
      },
    ],
  },
  {
    id: "8",
    title: "新人报到，请多关照",
    author: "一只小团子",
    date: "2026-10-08",
    updatedAt: "2026-10-10 18:12",
    replyCount: 33,
    heat: 72,
    essence: false,
    excerpt:
      "刚发现这个社区，看了一圈感觉氛围很温和，先来打个招呼。",
    content: [
      "刷视频的时候偶然看到这里的推荐，进来逛了一圈，发现大家都在很认真地讨论「怎么让彼此更舒服」。",
      "我属于比较内向的类型，先潜水一段时间，慢慢学习一下大家的经验。",
      "希望能在这里认识一些同样喜欢轻松内容的朋友。",
    ],
    replies: [
      {
        author: "暖光小屋",
        date: "2026-10-09 09:05",
        content: "欢迎欢迎，先看看置顶的社区公约，其他的慢慢来就好。",
      },
      {
        author: "橘子汽水",
        date: "2026-10-10 18:12",
        content: "欢迎新人，这里确实挺温和的，放心逛。",
      },
    ],
  },
];